<template>

  <FormItem
    class="card-no-group"
    :prop="prop"    
    :label="label"
    :label-width="labelWidth"
  >      
    <Row
    :gutter="8"
    :style="{margin: '0px'}"
    >
      <Col
        :lg="value.carType === undefined? 11:7"
        :md="value.carType === undefined? 11:7"
        :xs="11"
      >      
        <Input
          :value="value.block1"
          size="large"
          :style="inputStyle"
          :maxlength="4"
          placeholder="車牌(前)"
          @on-change="handleChange('block1',$event)"
        />
      </Col>
      <Col
        :xs="1"
        :md="1"
        :lg="1"
        :style="{ maxWidth: '15px', textAlign: 'center',height: '45px'}"
      >
        <span class="divide" />
      </Col>
      <Col
        :lg="value.carType === undefined? 12:8"
        :md="value.carType === undefined? 12:8"
        :xs="12"
      >
        <Input
          :value="value.block2"
          size="large"
          :style="inputStyle"
          :maxlength="5"
          placeholder="車牌(後)"
          @on-change="handleChange('block2',$event)"
        />
      </Col>
      <Col
        v-if="value.carType !== undefined"
        :md="8"
        :xs="11"
      >
        <Select
          size="large"
          :value="value.carType"
          placeholder="您的車種"
          @on-change="handleChange('carType',$event)"
        >
          <Option
            v-for="option in carType"
            :key="`option-${option.value}`"
            :value="option.value"
            :label="option.label"
          />
        </Select>
        <Spin
          v-if="loading"
          fix
        />
      </Col>
    </Row>
  </FormItem>
</template>

<script>
  import { FormItem, Input, Select, Option, Row, Col,Spin } from 'iview';

  export default {
    components: { FormItem, Input, Select, Option, Row, Col,Spin },
    props: {
      prop: {
        type: String,
        default: null
      },
      label: {
        type: String,
        default: '牌照號碼'
      },
      showCarType: {
        type: Boolean,
        default: false
      },
      labelWidth: {
        type: Number,
        default: null
      },
      value: {
        type: Object,
        default: () => ({
          block1: '',
          block2: '',
          carType: ''
        })
      },      
      carType: {
        type: Array,
        default: null
              },
      loading: {
        type: Boolean,
        default: false
      },
      onlyCarNo: {
        type: Boolean,
        default: false,
      },   
Carno: {
        type: String,
        default() {
           
       // console.log(this.$route.params.carno);
          return this.$route.params.carno==null? '' :this.$route.params.carno;
        }
      } 
    /*  insuId:
      {
        type: String,
      }*/
    },
    data() {
      return {
        // val: this.value
        carNo:this.Carno,
        
        //console.log(this.carNo);
      };
    },
    computed: {
      inputStyle() {
        const width = this.value.carType === undefined
          ? 'calc((100% - 12px)/2)'
          : '130px';
        return { padding: '0px' };
      },
    },
    methods: {
      handleChange(key,e) {
        let payload = {}
        if(key === 'carType') {
          payload = {
            ...this.value,
            [key]: e
          };
        }    
        else{
          payload = {
            ...this.value,
            [key]: e.target.value.toUpperCase()
          };
        }
        this.$emit('input', payload);
      },
    }
  };
</script>

